import React from 'react';
import classNames from 'classnames';
import {Dummy} from '../';
import styles from './style.css';

export default class Vent extends Dummy {

    render() {
        let ventClass = {};

        const disabled = this.props.power.disabled || this.props.fault.disabled;
        if (!disabled) {
            ventClass[styles.ventOn] = this.props.power.cleaned && !this.props.fault.cleaned;
            ventClass[styles.ventOff] = !this.props.power.cleaned && !this.props.fault.cleaned;
            ventClass[styles.ventAvar] = this.props.fault.cleaned;
        }
        ventClass[styles.disabled] = disabled;
        let vClass = classNames(styles.vent, ventClass);
        return (
            <div className={vClass} id={this.props.div_id}>
            </div>
        );
    }
}

Vent.propTypes = {
    div_id: React.PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/entries/Vent/index.jsx